import { usePostHog } from 'posthog-js/react';
import { SyntheticEvent } from 'react';
import { useForm } from 'react-hook-form';
import { createSearchParams } from 'react-router-dom';
import { useAnalytics } from 'use-analytics';
import { PostHogFeatureFlagEnum } from '../../enum/PostHogEvent.enum';
import { SocialPlatformEnum } from '../../enum/SocialPlatform.enum';

interface RegisterFormInputs {
  tos_consent: boolean;
  pp_consent: boolean;
  marketing_consent: boolean;
}

// Key for storing OAuth tracking data in localStorage
export const OAUTH_TRACKING_KEY = 'posthog_oauth_tracking';

export const useSocialRegister = () => {
  const { track } = useAnalytics();
  const postHog = usePostHog();

  const { trigger } = useForm<RegisterFormInputs>();

  const handleSocialRegister = async (
    _: SyntheticEvent,
    type: SocialPlatformEnum,
  ): Promise<void> => {
    const result = await trigger();

    if (result) {
      const query = createSearchParams({
        tos_consent: 'true',
        pp_consent: 'true',
        marketing_consent: 'true',
      });

      if (type === SocialPlatformEnum.Google) {
        // Store variant in localStorage before OAuth redirect for tracking after success
        const backgroundVariant = postHog.getFeatureFlag(
          PostHogFeatureFlagEnum.SignupBackgroundTest,
        );
        localStorage.setItem(
          OAUTH_TRACKING_KEY,
          JSON.stringify({
            variant: backgroundVariant,
            provider: 'google',
            timestamp: Date.now(),
            is_registration: true,
          }),
        );

        track(
          'register_google_click',
          { event_category: 'User Registration', event_label: 'register_form' },
          () => {
            window.location.assign(`/login/google-oauth2/?${query}`);
          },
        );
      }
    }
  };

  return {
    handleSocialRegister,
  };
};
